import { createAction } from '@ngrx/store';

export const onClosedProfileSheetDialog = createAction(
  '[PROFILE SHEET DIALOG] on close profile sheet dialog'
);

export const onOpenSheetPageProfileDialog = createAction(
  '[PROFILE SHEET DIALOG] on open sheet page profile dialog'
);
